import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';

import { Prop, RequiredOnly, isNumber, isObject } from '@daikin-tic/dxone-com-lib';

export const PAST_DAYS = 31;
export const FUTURE_DAYS = 14;

export const MONTHS = [
  T('core.period-picker.label.january'),
  T('core.period-picker.label.february'),
  T('core.period-picker.label.march'),
  T('core.period-picker.label.april'),
  T('core.period-picker.label.may'),
  T('core.period-picker.label.june'),
  T('core.period-picker.label.july'),
  T('core.period-picker.label.august'),
  T('core.period-picker.label.september'),
  T('core.period-picker.label.october'),
  T('core.period-picker.label.november'),
  T('core.period-picker.label.december'),
];

export const WEEKDAYS = [
  T('core.period-picker.label.monday'),
  T('core.period-picker.label.tuesday'),
  T('core.period-picker.label.wednesday'),
  T('core.period-picker.label.thursday'),
  T('core.period-picker.label.friday'),
  T('core.period-picker.label.saturday'),
  T('core.period-picker.label.sunday'),
];

export const toDateStruct = (date: dayjs.Dayjs): NgbDateStruct => {
  return { year: date.year(), month: date.month() + 1, day: date.date() };
};

export const toDayjs = (date: NgbDateStruct): dayjs.Dayjs =>
  dayjs()
    .tz()
    .set({ year: date.year, month: date.month - 1, date: date.day });

export type Period = { from: number; to: number };

export function isPeriod(value: unknown): value is Period {
  const nProps: Prop<RequiredOnly<Period>, number>[] = ['from', 'to'];
  return isObject(value) && nProps.every(prop => isNumber(value[prop]));
}
